// NOTE: no static (or dynamic) import of ./ssr-fetch here. This module sits in
// the home route's client graph, and TanStack Start's import-protection denies
// @tanstack/react-start/server there — the transport (cookie-forwarding server
// fn on SSR, direct apiClient call in the browser) is chosen by the caller via
// the injected `request` fn (see homepage-fns.ts → authenticatedGetShared).

export const HOME_FEATURE_REQUESTS_PATH = '/v2/homepage/feature-requests';
export const HOME_UPCOMING_CLASSES_PATH = '/v2/homepage/upcoming-classes';

type SectionRequest = <T>(path: string) => Promise<T>;

export const fetchHomepageSection = async <T>(
  path: string,
  field: string,
  request: SectionRequest
): Promise<T[]> => {
  const data = await request<Record<string, unknown>>(path);
  if (!Array.isArray(data[field])) {
    throw new Error(`Homepage ${field} response was invalid`);
  }
  return data[field] as T[];
};
